import { component } from 'picoapp';
import { merge } from 'lodash';
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/modules/navigation/navigation.min.css';
const str2json = require('../../utils/str2json');


class AnnouncementBar {
  constructor(el) {
    if (!el) {
      return;
    }
    this._init(el);
    // this.bindEvents();
  }

  _init(el) {
    this.el = el;

    this.defaults = {
      modules: [Navigation, Autoplay],
      observer: true,
      createElements: true,
      loop: true,
      grabCursor: true,
      slidesPerView: 1,
      navigation: {
        auto: true,
        prevEl: this.el.parentNode.querySelector('.swiper-button-prev'),
        nextEl: this.el.parentNode.querySelector('.swiper-button-next')
      },
      autoplay: {
        delay: 5000
      }
    }
    this.options = merge(this.defaults, str2json(this.el.dataset.options));
    const swiper = new Swiper(this.el, this.options);


  }
}


export default component((node, ctx) => {
  new AnnouncementBar(node, ctx);
});
